
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ShipFrom } from '@/features/shipment/types';
import { ScheduleDataType } from '@/features/schedule-pickup/types';
import { pickUpLocations } from '@/features/common/raw';
import { useFormatTimestamp } from '@/features/common/helpers';

@Component
export default class PickupInfo extends Vue {
  @Prop({ required: true }) scheduleData!: ScheduleDataType;

  @Prop({ required: true }) fromAddress!: ShipFrom | null;

  get fromCountryName(): string {
    if (!this.fromAddress || !this.fromAddress.countryCode) return '';
    const countryInfo = this.$store.getters.getCountryFromCode(this.fromAddress.countryCode);
    if (!countryInfo) return '';
    return countryInfo.country;
  }

  get pickupLocation(): string {
    const locationEnum = this.scheduleData.pickupLocation;
    if (!locationEnum) return '';
    return pickUpLocations.find(
      (location) => location.value === locationEnum,
    )?.text || '';
  }

  private useFormatTimestamp = useFormatTimestamp;
}
